import { render, staticRenderFns } from "./PublicShare.vue?vue&type=template&id=881a0990&scoped=true"
import script from "./PublicShare.vue?vue&type=script&lang=js"
export * from "./PublicShare.vue?vue&type=script&lang=js"
import style0 from "./PublicShare.vue?vue&type=style&index=0&id=881a0990&prod&lang=scss&scoped=true"
import style1 from "./PublicShare.vue?vue&type=style&index=1&id=881a0990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881a0990",
  null
  
)

export default component.exports